// ©2024 Austin App House. All rights reserved.
import React from 'react';
import axios from 'axios';
import fileDownload from 'js-file-download';
import Notification from '../notification';
import DashboardIcon from '../dashboard/icons/DashboardIcon';

const BankInfoButton = () => (
  <button
    type="button"
    className="sidebar-link sidebar-link--export"
    title="Export bank info"
    onClick={(e) => {
      e.preventDefault();
      exportBankInfoContractors();
    }}
  >
    <span className="sidebar-icon">
      <DashboardIcon name="export" />
    </span>
    <span className="sidebar-label">Export bank info</span>
  </button>
);

export default BankInfoButton;

const exportBankInfoContractors = async () => {
  await axios.get('/api/admin/contractors/bankinfo/export', {
    responseType: 'blob',
  }).then((res) => {
    fileDownload(res.data, 'bankinfo.xlsx');
  }).catch((error) => {
    Notification('error', {
      message: error.response?.data?.message || error.message,
    });
  });
};
